const trxNotifications = {
  title: 'TRANSACTION NOTIFICATION',
  ids: [
    'payment_made',
    'payment_success',
    'payment_reminder',
    'payment_limit',
    'failure',
    'risk_notification'
  ]
};
const accNotifications = {
  title: 'ACCOUNT NOTIFICATION',
  ids: [
    'account_created',
    'kyc_status',
    'kyc_upgrade',
    'account_enquires',
    'account_blocked',
    'account_activated'
  ]
};
const promotionNotifications = {
  title: 'PROMOTIONAL AND MARKETING',
  ids: [
    'is_subbed'
  ]
};

module.exports = [
  trxNotifications,
  accNotifications,
  promotionNotifications
]
